import { ISpacePoint, IWidgetBlockSettings, SpaceGeometryTypePoint } from '.';

export interface WindBarsSettings extends IWidgetBlockSettings {
    bars: Bar[];
    title: string;
    mode?: 'cozy' | 'compact';
}

export interface Bar {
    id: string;
    space: ISpacePoint;
    datasetId?: string;
    min: number;
    max: number;
    step: number;
    unit: string;
    unitLabel: string;
    warningThreshold?: number;
    alertThreshold?: number;
    location?: string;
}

export const defaultSettings: WindBarsSettings = {
    title: 'Wind speed',
    fontSize: 100,
    bars: [
        {
            id: 'bar1',
            space: {
                type: SpaceGeometryTypePoint,
                coordinates: [173, -40],
            },
            min: 0,
            step: 10,
            max: 70,
            unit: 'kt',
            unitLabel: 'kt',
        },
        {
            id: 'bar2',
            space: {
                type: SpaceGeometryTypePoint,
                coordinates: [173, -40],
            },
            min: 0,
            step: 10,
            max: 60,
            unit: 'kph',
            unitLabel: 'kph',
        },
    ],
};

export interface IWindBarData {
    obs_timestamp: string;
    windlul_10mnmin: number;
    windgst_10mnmax: number;
    windspd_10mnavg: number;
    windspd_01mnavg: number;
}
